<template>
  <div>
    <van-nav-bar
        title="客户信息列表"
        right-text="搜索"

        @click-right="show = true"/>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <van-address-list
          v-model="chosenContactId"
          :list="list"
          default-tag-text="未更新"
          add-button-text="新增商户"
          @add="onAdd"
          @edit="onEdit"
      />
    </van-list>

    <van-dialog v-model="show" title="搜索" @confirm="ssConfirm" show-cancel-button>
      <van-field
          v-model.trim="form.unitName"
          maxlength="100"
          label="商铺名称"
          placeholder="商铺名称"
      />
      <van-field
          v-model.trim="form.dzCountyText"
          label="区/县"
          readonly
          @click="qxClick"
          placeholder="区/县"
      />
      <van-field
          v-model.trim="form.dzShreetText"
          label="街道/乡"
          readonly
          @click="jxClick"
          placeholder="街道/乡"
      />
      <van-field
          v-model.trim="form.waterMeterNo"
          label="水表号"
          placeholder="水表号"
      />
    </van-dialog>
    <van-popup v-model="qxShow" position="bottom" >
      <van-picker
          title="区/县"
          show-toolbar
          :columns="qxColumns"
          @confirm="qxConfirm"
          @cancel="qxShow = false"
      />
    </van-popup>
    <van-popup v-model="jxShow" position="bottom" >
      <van-picker
          title="街道/乡"
          show-toolbar
          :columns="jxColumns"
          @confirm="jxConfirm"
          @cancel="jxShow = false"
      />
    </van-popup>

  </div>
</template>
<script>
import Vue from "vue";
import {
  ContactList, Toast, Dialog, AddressList, Picker, Popup, Field, List

} from "vant";
Vue.use(ContactList);
Vue.use(Dialog)
Vue.use(AddressList);
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Field)
Vue.use(List)
export default {
  data() {
    return {
      show:false,
      qxShow:false,
      jxShow:false,
      loading: false,
      finished: false,
      qxColumns:[],
      jxColumns:[],
      chosenContactId: '1',
      list: [],
      listIndex:1,
      form:{
        khName:null,
        dzCounty:null,
        dzCountyText:null,
        dzShreet:null,
        dzShreetText:null,
        waterMeterNo:null,
        whetherUnits:'0',
        addUserid:null,
      }
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      console.log(localStorage.getItem("sanitationUsername"))
      var that = this
      this.$axios
          .get("/memberBusiness/customer/"+this.listIndex+"/10/customerList",this.form).then((data) => {
        console.log(data.content)
          data.content.forEach((d)=>{
              that.list.push({id:d.id,name:d.unitName,tel:d.contactNumber!==null?d.contactNumber:d.mail,address:d.dzXxdz!==null?d.zcdz+d.dzXxdz:"",isDefault:d.confirmStatus==="2"?true:false})
          })
      })

       that.qxColumns.push({text:'全部',value:''})
      that.qxColumns.push({text:'新罗区',value:'350802'})
      // this.$axios
      //     .get('/memberBusiness/sysArea/sysareaList',{parentId:'350800'}
      //     )
      //     .then((data) => {
      //       that.qxColumns.push({text:'全部',value:''})
      //       data.obj.forEach((a)=>{
      //         that.qxColumns.push({text:a.name,value:a.id})
      //         that.qxColumns.push({text:'新罗区',value:a.id})
      //       })
      //     })
      //     .catch(
      //         function (response) {
      //           this.$message.error('操作失败请重试');
      //         }.bind(this)
      //     );
    },
    ssConfirm(){
      var that = this
      this.listIndex=1;
      console.log(this.form)
      this.form.addUserid= "1"
  console.log(this.form)
      this.$axios
          .get("/memberBusiness/customer/"+this.listIndex+"/10/customerList",this.form).then((data) => {
        that.list = []
        data.content.forEach((d)=>{
          that.list.push({id:d.id,name:d.unitName===null?'':d.unitName,tel:d.contactNumber===null?d.mail:d.contactNumber,address:d.zcdz+d.dzXxdz,isDefault:d.confirmStatus==="1"?false:true})
        })
      })
      this.form.addUserid=null;
    },
    onLoad(){
      this.listIndex ++
      this.loading = false;
      this.finished = false;
    },
    onAdd() {
      this.$router.push({ path: "/unitInformationCollection" });
    },
    onEdit(item) {
      sessionStorage.setItem('sjrymx',item.id)
      this.$router.push({ path: "/unitInformationCollection" });
    },
    qxClick(){
      this.qxShow = true
    },
    onSelect(contact) {
      Toast('选择' + contact.id);
    },
    back(){
    },
    jxClick(){
      this.jxShow = true
    },
    returnLogin(){
      localStorage.removeItem("sanitationAccessToken")
      localStorage.removeItem("sanitationUsername")
      this.$router.push({path: '/login'})
    },
    qxConfirm(item){
      var that = this
      this.$axios
          .get('/memberBusiness/sysArea/sysareaList',{parentId:item.value})
          .then((data) => {
            that.jxColumns = [{text:'全部',value:''}]
            data.obj.forEach((a)=>{
              that.jxColumns.push({text:a.name,value:a.id})
            })
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
      this.form.dzShreet = ''
      this.form.dzShreetText = ''
      this.form.dzCounty = item.value
      this.form.dzCountyText = item.text
      this.qxShow = false
    },
    jxConfirm(item){
      this.form.dzShreet = item.value
      this.form.dzShreetText = item.text
      this.jxShow = false
    },
  },
};
</script>

<style scoped>
/deep/ .van-radio__icon {
  display: none;
}
/deep/ .van-address-list__bottom {
  bottom: 50px;
}
.van-radio-group{
  margin-bottom: 20px;
}
</style>